import { render, staticRenderFns } from "./returned_orders_queue.vue?vue&type=template&id=28183e9c&"
import script from "./returned_orders_queue.vue?vue&type=script&lang=js&"
export * from "./returned_orders_queue.vue?vue&type=script&lang=js&"
import style0 from "./returned_orders_queue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports